"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateClient = exports.getClients = exports.getClientCount = exports.getClientById = exports.deleteClient = exports.defaultClientData = exports.createClient = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultClientData = exports.defaultClientData = {
  id: 0,
  enabled: true,
  prefix: '',
  name: '',
  contactNumber: null,
  emailAddress: null,
  industriesId: null,
  industries: null,
  lastLeadStatus: null,
  website: null,
  gstNumber: null,
  panNumber: null,
  categorization: null,
  companyId: null,
  deliveryLocation: null,
  logo: null,
  rating: 0,
  paymentTerms: '',
  isVisibleOnWeb: false
};
const getClients = params => (0, _request.default)({
  url: '/clients',
  method: 'get',
  params
});
exports.getClients = getClients;
const getClientById = id => (0, _request.default)({
  url: `/clients/${id}`,
  method: 'get'
});
exports.getClientById = getClientById;
const updateClient = (id, data) => (0, _request.default)({
  url: `/clients/${id}`,
  method: 'patch',
  data
});
exports.updateClient = updateClient;
const deleteClient = id => (0, _request.default)({
  url: `/clients/${id}`,
  method: 'delete'
});
exports.deleteClient = deleteClient;
const createClient = data => (0, _request.default)({
  url: '/clients',
  method: 'post',
  data
});
exports.createClient = createClient;
const getClientCount = params => (0, _request.default)({
  url: '/clients/count',
  method: 'get',
  params
});
exports.getClientCount = getClientCount;